import { AnimatePresence } from 'framer-motion';
import { ModalRoot } from '@/components/ui/ModalRoot';
import { Z_DIALOGS_HIGH } from '@/lib/zIndex';

interface BetaOnboardingModalProps {
  open: boolean;
  onAcknowledge: () => void;
}

/**
 * Phase 15.2.2 — Erscheint beim Erststart VOR dem CityPicker. Erklärt
 * Beta-Status, Speicher-Verhalten und wie man Bugs meldet.
 */
export function BetaOnboardingModal({ open, onAcknowledge }: BetaOnboardingModalProps) {
  return (
    <AnimatePresence>
      {open && (
        <ModalRoot
          onClose={onAcknowledge}
          zIndex={Z_DIALOGS_HIGH}
          contentClass="w-full max-w-xl rounded-lg border border-amber-500/40 bg-bg-secondary"
          disableEscClose
        >
          <div className="border-b border-amber-500/40 bg-amber-500/15 px-6 py-4">
            <p className="font-display text-xl font-bold">
              <span aria-hidden>🧪</span> Willkommen in der Dispatch24 Closed Beta
            </p>
          </div>

          <div className="space-y-5 px-6 py-6 text-sm leading-relaxed text-fg-secondary">
            <p>
              Du gehörst zu den ersten Testern dieses Spiels. <strong>Danke!</strong>
            </p>

            <section>
              <p className="mb-2 font-semibold text-fg-primary">Was du wissen solltest:</p>
              <ul className="list-disc space-y-1 pl-5">
                <li>Das Spiel ist in aktiver Entwicklung — manche Sachen sind noch buggy</li>
                <li>Spielstände werden nur lokal in deinem Browser gespeichert</li>
                <li>Wenn du den Browser-Cache löschst, sind sie weg</li>
                <li>Bug gefunden? Klick jederzeit oben auf den gelben Banner</li>
              </ul>
            </section>

            <section>
              <p className="mb-2 font-semibold text-fg-primary">Bitte teste:</p>
              <ul className="list-disc space-y-1 pl-5">
                <li>Verschiedene Spielmodi (Klassik, Realistisch, Sandbox)</li>
                <li>Verschiedene Städte (deutsche, österreichische, schweizer)</li>
                <li>Verschiedene Mission-Typen (Feuerwehr, Rettung, Polizei)</li>
                <li>Mobile-Layout falls möglich</li>
              </ul>
            </section>

            <p className="text-xs text-fg-muted">
              Mit dem Klick auf „Verstanden" bestätigst du die{' '}
              <a
                href="/legal/privacy"
                rel="noopener noreferrer"
                className="text-accent-dispatch hover:underline"
              >
                Datenschutzerklärung
              </a>
              .
            </p>
          </div>

          <footer className="flex items-center justify-end border-t border-border-subtle bg-bg-primary px-6 py-4">
            <button
              type="button"
              onClick={onAcknowledge}
              data-testid="beta-onboarding-confirm"
              className="rounded-md bg-accent-emergency px-5 py-2 text-sm font-semibold text-white shadow-md transition hover:bg-accent-emergency-hover"
            >
              Verstanden, los geht's
            </button>
          </footer>
        </ModalRoot>
      )}
    </AnimatePresence>
  );
}
